import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterRewardEditPage } from './master-reward-edit.page';

const routes: Routes = [
  {
    path: '',
    component: MasterRewardEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterRewardEditPageRoutingModule {}
